import Icon from './Icon';
import { SUPPORT_PHONE_LABEL, SUPPORT_PHONE_TEL } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function StuckCta() {
  return (
    <section className="section">
      <div className="shell">
        <div className="stuck">
          <div className="stuck__glow" aria-hidden="true" />
          <div className="stuck__text">
            <p className="kicker">Still stuck?</p>
            <h2>Don’t let one error hold up your books</h2>
            <p>
              Call or chat with a certified expert, go through the message together and get a
              fixed price before anything is changed.
            </p>
          </div>
          <div className="stuck__actions">
            <a href={SUPPORT_PHONE_TEL} className="btn btn--green">
              <Icon name="phone" size={18} />
              Call {SUPPORT_PHONE_LABEL}
            </a>
            <button type="button" className="btn btn--green-line" onClick={openZohoChat}>
              <Icon name="chat" size={18} />
              Start live chat
            </button>
            <a href="#consultation" className="btn btn--quiet">
              Request a callback
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
